<template>
    <transition name="fade">
        <div class="share-modal">
            <div v-on-clickaway="closeModal" class="modal-content relative">
                <div class="modal-header flex justify-between justify-start">
                    <h3 class="font-size-20 shadow-text-none p-0 m-0">
                        {{ $t('quiz_thumbnail_share_quiz_modal_header') }}
                    </h3>
                    <div class="leading-none">
                        <i @click="closeModal" class="fas fa-times text-xl shadow-text-none cursor-pointer"></i>
                    </div>
                </div>
                <div class="modal-body text-center">
                    <XInput
                        @focus.native="onFocus"
                        :value="value"
                        :readonly="true"
                        class="my-5 url-input w-full p-4 md:font-size-18"
                    />
                    <div class="flex justify-center items-center mb-5">
                        <div class="w-48 h-48">
                            <Qrcanvas
                                :class="{
                                    'qrcode w-full h-full rounded border-8 border-solid border-white': true,
                                    show: true
                                }"
                                :options="qrCodeOptions"
                            ></Qrcanvas>
                        </div>
                    </div>
                    <div>
                        <XButton
                            @click="onCopied"
                            class="w-full shadow-text-none system-button-color system-button-text-color"
                        >
                            <i class="fas fa-paste"></i>
                            <template>{{ $t('playalone_copy_share_url') }}</template>
                        </XButton>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import XInput from '@/components/v2/XInput'
import XButton from '@/components/v2/XButton'
import popup from '@/lib/popup.js'
import { directive as onClickaway } from 'vue-clickaway'
import Qrcanvas from 'qrcanvas-vue'

export default {
    name: 'share-quiz-modal',

    components: {
        XInput,
        XButton,
        Qrcanvas
    },

    directives: {
        onClickaway: onClickaway
    },

    props: {
        value: String
    },

    computed: {
        qrCodeOptions() {
            return {
                cellSize: 6,
                data: this.value
            }
        }
    },

    methods: {
        onFocus(e) {
            e.target.select()
        },

        closeModal() {
            this.$emit('close')
        },

        onCopied() {
            if (window.navigator.share) {
                navigator.share({
                    title: 'TheBigQuiz',
                    text: 'TheBigQuiz',
                    url: this.value
                })
            } else {
                navigator.clipboard.writeText(this.value).then(() => {
                    popup.alert(this.$t('quiz_thumbnail_share_quiz_modal_link_copied'), () => {}, {
                        icon: 'success'
                    })
                })
            }
        }
    }
}
</script>

<style lang="scss" scoped>
$input-border-color: #cbcbcb;

.share-modal {
    font-family: 'Open Sans', sans-serif !important;
    background-color: rgba(0, 0, 0, 0.2);
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: start;
    font-size: 1.2em;
    z-index: 9999;

    .modal-content {
        background-color: #fff;
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        padding: 1rem 1.5rem;
        width: 500px !important;
        overflow: hidden;
        border-radius: 3px;
        box-shadow: 2px 2px 20px rgba(0, 0, 0, 0.6);

        @media (max-width: 500px) {
            width: 90% !important;
            margin: 1rem 0.5rem;
        }

        .modal-body {
            margin: 0 0 1rem 0;

            .url-input {
                border: 1px solid $input-border-color;
            }
        }
    }
}
</style>
